import React from "react";
import cn from "classnames";

import { LinkProps } from "./Link.props";
import styles from "../Link.module.scss";

/**
 * @deprecated Use `import { Link } from capitalrx-components-2.0/lib/general` instead.
 */
const Link: React.FC<LinkProps> = ({ children, id, testId, size = "reg", className, href, title }: LinkProps): JSX.Element => {
  const LinkClasses = cn(
    [styles.a],
    { [styles.xsmall]: size === "xsmall" },
    { [styles.small]: size === "small" },
    { [styles.large]: size === "large" },
    { [styles["small-display"]]: size === "small-display" },
    className,
  );

  return (
    <a
      href={href}
      className={LinkClasses}
      id={id}
      title={title}
      data-testid={testId ? `test__${testId}` : undefined}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

export default Link;
